import { Checkbox, Skeleton, useTheme } from "@mui/material";
import * as React from "react";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";
import {
  getCurrentSizeProfile,
  responsiveFontSize,
} from "@common/components/Typography/style";

import { useMemo } from "react";

interface BookmarkIcon {
  state?: boolean;
  icon?: React.JSX.Element;
  checkedIcon?: React.JSX.Element;
  changeState: Function;
  button?: boolean;
}

export type BookmarkIconProps =
  | ({ skeleton: true } & Partial<BookmarkIcon>)
  | ({ skeleton?: false } & BookmarkIcon);

export const BookmarkIconSkeleton = (
  props: React.PropsWithChildren<BookmarkIconProps>
) => {
  return (
    <Skeleton variant="circular">
      <Checkbox />
    </Skeleton>
  );
};
const BookmarkIcon = (props: React.PropsWithChildren<BookmarkIconProps>) => {
  if (props.skeleton) return <BookmarkIconSkeleton {...props} />;
  const { state, icon, checkedIcon, changeState, button = false } = props;
  const theme = useTheme();

  const BookmarkIconComputeStyle = useMemo(() => {
    return {
      display: "flex",
      fontSize: getCurrentSizeProfile().small,
      ...responsiveFontSize(theme, "small"),
      height: "2em",
      "&.MuiCheckbox-root": {
        color: theme.palette.background.highlight,
      },
      "&.Mui-checked": {
        color: theme.palette.common.white,
      },
    };
  }, [theme]);

  const ButtonComputeStyle = useMemo(() => {
    return {
      "&.MuiCheckbox-root": {
        border: `1px solid ${theme.palette.background.highlighter}`,
        borderRadius: theme.shape.borderRadius,
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        color: theme.palette.background.highlight,
        "&.Mui-checked": {
          backgroundColor: theme.palette.background.highlighter,
          color: theme.palette.common.white,
          "&:hover": {
            backgroundColor: theme.palette.grey[100],
          },
        },
      },
    };
  }, [theme]);
  return (
    <Checkbox
      icon={icon || <StarBorderIcon />}
      checked={state}
      checkedIcon={checkedIcon || <StarIcon />}
      sx={[BookmarkIconComputeStyle, button ? ButtonComputeStyle : {}]}
      onChange={() => changeState(!state)}
      color="default"
    />
  );
};

export default BookmarkIcon;
